import styled, { css } from 'styled-components';
import { Anchor } from '@klv/atoms/anchor';
import Eyebrow from './eyebrow';
import Headline from './headline';
import Navigation from './navigation';
import Paragraph from './paragraph';
import Tagline from './tagline';
import TestimonialsQuote from './testimonials-quote';
import type { ITypography } from './types';

const variants = {
  articleLeadIn: '',
  chartHeadline: Headline,
  contentHeaderListView1: Headline,
  contentHeaderListView2: Headline,
  display1: Headline,
  display2: Headline,
  display3: Headline,
  disclaimer: '',
  editorial: Headline,
  eyebrow: Eyebrow,
  formLarge: '',
  formRegular: '',
  formSmall: '',
  h1: Headline,
  h1Semibold: Headline,
  h2: Headline,
  h3: Headline,
  h3Semibold: Headline,
  h4: Headline,
  h4Semibold: Headline,
  h5: Headline,
  h5Semibold: Headline,
  h6: Headline,
  h6Semibold: Headline,
  navigation: Navigation,
  quoteLarge: Headline,
  quoteSmall: Headline,
  paragraph1: Paragraph,
  paragraph1Semibold: Paragraph,
  paragraph2: Paragraph,
  paragraph2Semibold: Paragraph,
  paragraph3: Paragraph,
  paragraph3Semibold: Paragraph,
  tagline: Tagline,
  taglineSemibold: Tagline,
  testimonialsQuote: TestimonialsQuote,
};

const base = css<ITypography>`
${({ colorVariant, theme, variant }) => `
    ${theme.typography.variants[variant].fontFace}
    color: ${colorVariant ? theme.typography.colors[colorVariant].text : 'inherit'};
    font-size: ${theme.typography.variants[variant].fontSize};
    line-height: ${theme.typography.variants[variant]?.lineHeight ?? ''};
  `}
  ${({ variant }) => variants[variant]}
`;

export const GTypographyLinkBase = styled(Anchor)<ITypography>`${base}`;

export const TypographyBase = styled.div<ITypography>`${base}`;
